import { React, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ReactComponent as DashboardSvg } from "../images/dashboard (1).svg";
import { ReactComponent as AppSvg } from "../images/all apps.svg";
import { ReactComponent as EmployeeSvg } from "../images/employe.svg";
import { ReactComponent as ProjectSvg } from "../images/projects.svg";
import { ReactComponent as TestDataSvg } from "../images/test data.svg";
import { ReactComponent as LeaveSvg } from "../images/leave.svg";
import { ReactComponent as SalarySvg } from "../images/salary.svg";
import { ReactComponent as RoleSvg } from "../images/role.svg";
import { ReactComponent as CategorySvg } from "../images/category.svg";
import { ReactComponent as HolidaySvg } from "../images/holyday.svg";
import logo from "../images/tapas.png";
import { getApi } from "../helpers/api";
function SideBar({ userData }) {
  const user = useSelector((state) => state.user.user);
  const currentPath = useLocation().pathname.split("/");
  const activeTab = "#2281E3";
  const deactiveTab = "#575A74";
  const permission = JSON.parse(user?.permission);
  const [showDiv, setShowDiv] = useState(false);
  console.log("🚀 ~ SideBar ~ showDiv:", showDiv)
  
  const [startHour, setStartHour] = useState('');
  const [endHour, setEndHour] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getApi('get-time', true);
        if (res.status === 200) {
          const endTime = res.data.end_time;
          const [hour] = endTime.split(':').map(Number);
          setStartHour(hour);
          setEndHour(hour + 2);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const checkTime = () => {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      if (
        (currentHour > startHour && currentHour < endHour) ||
        (currentHour === startHour && currentMinute >= 0) ||
        (currentHour === endHour && currentMinute <= 59)
      ) {
        setShowDiv(true);
      } else {
        setShowDiv(false);
      }
    };

    // Initial check
    checkTime();

    // Check every minute
    // Check every 16 hours (16 hours * 60 minutes * 60 seconds * 1000 milliseconds)
    const timer = setInterval(checkTime, 16 * 60 * 60 * 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, [startHour, endHour]);
  return (
    <>
      {
        <div className="sidebar">
          <div className="brand-link">
            <Link path="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="sidemenus">
            <p className="menu-title">General</p>
            <ul className="sidemenu">
              {(user.userRole.role_name === "admin" || permission?.home) && (
                <li>
                  <Link
                    to="/dashboard"
                    className={`menuitem ${
                      currentPath.includes("dashboard") ? "active" : ""
                    }`}
                  >
                    <DashboardSvg />
                    <div
                      className={`menu-item ${
                        currentPath.includes("dashboard") ? "active" : ""
                      }`}
                    >
                      Dashboard
                    </div>
                  </Link>
                </li>
              )}
              {(user.userRole.role_name === "admin" || permission?.app_r) && (
                <li>
                  <Link
                    to={"/apps"}
                    className={`menuitem ${
                      currentPath.includes("apps") ||
                      currentPath.includes("add-app")
                        ? "active"
                        : ""
                    }`}
                  >
                    <AppSvg />
                    <div
                      className={`menu-item ${
                        currentPath.includes("apps") ||
                        currentPath.includes("add-app")
                          ? "active"
                          : ""
                      }`}
                    >
                      All Apps
                    </div>
                  </Link>
                </li>
              )}
              {user.userRole.role_name === "admin" && (                
                  <li>
                    <Link
                      to="/add-test-data/1"
                      className={`menuitem ${
                        currentPath.includes("add-test-data") ? "active" : ""
                      }`}
                    >
                      <TestDataSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("add-test-data") ? "active" : ""
                        }`}
                      >
                        Test Data
                      </div>
                    </Link>
                  </li>
                  )}
                  {(user.userRole.role_name === "admin" ||
                    permission?.project_r) && (
                    <li>
                      <Link
                        to="/projects"
                        className={`menuitem ${
                          currentPath.includes("projects") ? "active" : ""
                        }`}
                      >
                        <ProjectSvg />
                        <div
                          className={`menu-item ${
                            currentPath.includes("projects") ? "active" : ""
                          }`}
                        >
                          Projects
                        </div>
                      </Link>
                    </li>
                  )}
                    {user.userRole.role_name === "admin" && (
                      <>
                  <li>
                    <Link
                      to="/employee"
                      className={`menuitem ${
                        currentPath.includes("employee") ||
                        currentPath.includes("employee-profile") ||
                        currentPath.includes("attendance") ||
                        currentPath.includes("add-employee")
                          ? "active"
                          : ""
                      }`}
                    >
                      <EmployeeSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("employee") ||
                          currentPath.includes("employee-profile") ||
                          currentPath.includes("attendance") ||
                          currentPath.includes("add-employee")
                            ? "active"
                            : ""
                        }`}
                      >
                        Employee
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/leave"
                      className={`menuitem ${
                        currentPath.includes("leave") ? "active" : ""
                      }`}
                    >
                      <LeaveSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("leave") ? "active" : ""
                        }`}
                      >
                        Leave
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/salary"
                      className={`menuitem ${
                        currentPath.includes("salary") ? "active" : ""
                      }`}
                    >
                      <SalarySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("salary") ? "active" : ""
                        }`}
                      >
                        Salary
                      </div>
                    </Link>
                  </li>
                  {/* <li>
                    <Link to="/settings" className="menuitem">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_134_13)">
                          <path
                            d="M10.325 4.317C10.751 2.561 13.249 2.561 13.675 4.317C13.7389 4.5808 13.8642 4.82578 14.0407 5.032C14.2172 5.23822 14.4399 5.39985 14.6907 5.50375C14.9414 5.60764 15.2132 5.65085 15.4838 5.62987C15.7544 5.60889 16.0162 5.5243 16.248 5.383C17.791 4.443 19.558 6.209 18.618 7.753C18.4769 7.98466 18.3924 8.24634 18.3715 8.51677C18.3506 8.78721 18.3938 9.05877 18.4975 9.30938C18.6013 9.55999 18.7627 9.78258 18.9687 9.95905C19.1747 10.1355 19.4194 10.2609 19.683 10.325C21.439 10.751 21.439 13.249 19.683 13.675C19.4192 13.7389 19.1742 13.8642 18.968 14.0407C18.7618 14.2172 18.6001 14.4399 18.4963 14.6907C18.3924 14.9414 18.3491 15.2132 18.3701 15.4838C18.3911 15.7544 18.4757 16.0162 18.617 16.248C19.557 17.791 17.791 19.558 16.247 18.618C16.0153 18.4769 15.7537 18.3924 15.4832 18.3715C15.2128 18.3506 14.9412 18.3938 14.6906 18.4975C14.44 18.6013 14.2174 18.7627 14.0409 18.9687C13.8645 19.1747 13.7391 19.4194 13.675 19.683C13.249 21.439 10.751 21.439 10.325 19.683C10.2611 19.4192 10.1358 19.1742 9.95929 18.968C9.7828 18.7618 9.56011 18.6001 9.30935 18.4963C9.05859 18.3924 8.78683 18.3491 8.51621 18.3701C8.24559 18.3911 7.98375 18.4757 7.752 18.617C6.209 19.557 4.442 17.791 5.382 16.247C5.5231 16.0153 5.60755 15.7537 5.62848 15.4832C5.64942 15.2128 5.60624 14.9412 5.50247 14.6906C5.3987 14.44 5.23726 14.2174 5.03127 14.0409C4.82529 13.8645 4.58056 13.7391 4.317 13.675C2.561 13.249 2.561 10.751 4.317 10.325C4.5808 10.2611 4.82578 10.1358 5.032 9.95929C5.23822 9.7828 5.39985 9.56011 5.50375 9.30935C5.60764 9.05859 5.65085 8.78683 5.62987 8.51621C5.60889 8.24559 5.5243 7.98375 5.383 7.752C4.443 6.209 6.209 4.442 7.753 5.382C8.753 5.99 10.049 5.452 10.325 4.317Z"
                            stroke={
                              currentPath.includes("settings")
                                ? activeTab
                                : deactiveTab
                            }
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12Z"
                            stroke={
                              currentPath.includes("settings")
                                ? activeTab
                                : deactiveTab
                            }
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_134_13">
                            <rect width="24" height="24" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      <div
                        className={`menu-item ${
                          currentPath.includes("settings") ? "active" : ""
                        }`}
                      >
                        Settings
                      </div>
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to="/role"
                      className={`menuitem ${
                        currentPath.includes("role") ? "active" : ""
                      }`}
                    >
                      <RoleSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("role") ? "active" : ""
                        }`}
                      >
                        Designation
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/category"
                      className={`menuitem ${
                        currentPath.includes("category") ? "active" : ""
                      }`}
                    >
                      <CategorySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("category") ? "active" : ""
                        }`}
                      >
                        Project Category
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/holiday"
                      className={`menuitem ${
                        currentPath.includes("holiday") ? "active" : ""
                      }`}
                    >
                      <HolidaySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("holiday") ? "active" : ""
                        }`}
                      >
                        Holidays
                      </div>
                    </Link>
                  </li>
                  {showDiv &&
                  <li>
                    <Link
                        to={`/employeecheckout`}
                        className={`menuitem ${currentPath.includes("employeecheckout") ? "active" : ""
                        }`}
                    >
                      <EmployeeSvg />
                      <div
                          className={`menu-item ${currentPath.includes("employeecheckout") ? "active" : ""
                          }`}
                      >
                        Emp Check Out
                      </div>
                    </Link>
                  </li>}
                </>
              )}
              {user.userRole.role_name !== "admin" && (
                <>
                  {/* <li>
                    <Link
                      to={`/profile?employee=${user?.id}`}
                      className={`menuitem ${
                        currentPath.includes("profile") ? "active" : ""
                      }`}
                    >
                      <HolidaySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("profile") ? "active" : ""
                        }`}
                      >
                        Profile
                      </div>
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to={`/attendances`}
                      className={`menuitem ${
                        currentPath.includes("attendances") ? "active" : ""
                      }`}
                    >
                      <EmployeeSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("attendances") ? "active" : ""
                        }`}
                      >
                        Attendances
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/leaves`}
                      className={`menuitem ${
                        currentPath.includes("leaves") ? "active" : ""
                      }`}
                    >
                      <LeaveSvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("leaves") ? "active" : ""
                        }`}
                      >
                        Leave
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to={`/salarys`}
                      className={`menuitem ${
                        currentPath.includes("salarys") ? "active" : ""
                      }`}
                    >
                      <SalarySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("salarys") ? "active" : ""
                        }`}
                      >
                        Salary
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/holidays"
                      className={`menuitem ${
                        currentPath.includes("holidays") ? "active" : ""
                      }`}
                    >
                      <HolidaySvg />
                      <div
                        className={`menu-item ${
                          currentPath.includes("holidays") ? "active" : ""
                        }`}
                      >
                        Holidays
                      </div>
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      }
    </>
  );
}

export default SideBar;
